// @flow

import React from 'react'

const SvgHeart = () => (
  <svg width="16" height="15" xmlns="http://www.w3.org/2000/svg"><g fill="none" fillRule="evenodd"><path d="M8 14.68l-1.16-1.056C2.72 9.888 0 7.424 0 4.4 0 1.936 1.936 0 4.4 0A4.79 4.79 0 018 1.672 4.79 4.79 0 0111.6 0C14.064 0 16 1.936 16 4.4c0 3.024-2.72 5.488-6.84 9.232L8 14.68z" fill="#8383E7"/></g></svg>
)

export default SvgHeart